import { createSlice } from "@reduxjs/toolkit";
import { IUser } from "../../shared/interfaces/user/IUser";
import { ERole } from "../../shared/enums/user/ERole";
import { ETheme } from "../../shared/enums/user/ETheme";

export interface IAuthState {
  isAuthenticated: boolean;
  token: string;
  userData?: IUser;
}

const initialState: IAuthState = {
  isAuthenticated: false,
  token: "",
  userData: {
    roles: [],
    id: 0,
    createdAt: "",
    updatedAt: "",
    email: "",
    phoneNumber: "",
    enabled: false,
    firstName: "",
    lastName: "",
    theme: ETheme.LIGHT,
    language: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      state = action.payload;
      return state;
    },
    setLogoutState: (state) => {
      state = initialState;
      return state;
    },
  },
});

export default authSlice;
